import React, { useEffect, useRef, useState } from 'react';
import './AccessChallengeCamera.scss';
import { CommonAndroidWrapper, Challenge2026AndroidWrapper } from '../commonAndroidWrapper';
import { getChallengeImagesAction } from '../../../actions/challenge/challengeImageUploadActions';
import { getLocalStorage } from '../../../services/promotion/utils.service';
import { CHALLENGE_30_IMAGES, IMAGE_UPLOAD_PROPS } from '../../challengeConstants';
import { useDispatch } from 'react-redux';
import { ASSESSMENT_IMAGE_UPLOAD_PROPS, SKIN_ASM_CONSTANTS } from '../../skinAssessmentConstant';

export default function AccessChallengeCamera() {
  const imageRef = useRef(null);
  const androidFeatureRef = useRef(null);
  const dispatch = useDispatch();
  const [challengeObj, setChallengeObj] = useState(null);
  const [WrapperComponent, setWrapperComponent] = useState(null);

  const isAssessment = challengeObj?.source === SKIN_ASM_CONSTANTS.ASSESSMENT_KEY;

  useEffect(() => {
    const onMount = async () => {
      const assessmentPropsString = await getLocalStorage(ASSESSMENT_IMAGE_UPLOAD_PROPS);
      const isChallenge30Upload = await getLocalStorage(CHALLENGE_30_IMAGES);
      setWrapperComponent(() => (isChallenge30Upload ? Challenge2026AndroidWrapper : CommonAndroidWrapper));
      if (assessmentPropsString) {
        const assessmentProps = JSON.parse(assessmentPropsString);
        setChallengeObj(assessmentProps);
        return;
      }

      const uploadPropsString = await getLocalStorage(IMAGE_UPLOAD_PROPS);
      const uploadProps = uploadPropsString ? JSON.parse(uploadPropsString) : null;
      setChallengeObj(uploadProps);
      if (uploadProps.eventId && uploadProps.userId) {
        dispatch(
          getChallengeImagesAction({
            eventId: uploadProps.eventId,
            userId: uploadProps.userId,
            scoreId: null,
          }),
        );
      }
    };
    onMount();
  }, []);

  return (
    <div className="custom-android-camera">
      {WrapperComponent && (
        <WrapperComponent
          eventId={isAssessment ? null : challengeObj?.eventId}
          partyId={isAssessment ? null : challengeObj?.partyId}
          aboId={isAssessment ? null : challengeObj?.aboId}
          userId={isAssessment ? null : challengeObj?.userId}
          redirectionEventIdQuery={challengeObj?.redirectionEventIdQuery}
          onAssessmentImageConfirm={() => { }}
          ref={androidFeatureRef}
          imageRef={imageRef}
          photos={null}
          setPhotos={() => { }}
          componentInstance={'CAMERA'}
        />
       )}
    </div>
  );
}
